$(document).ready(function(){
  
  	Currency.format = 'money_format';
  

  var shopCurrency = 'GBP'; /*';*/

  /* Sometimes merchants change their shop currency, let's tell our JavaScript file */
  Currency.moneyFormats[shopCurrency].money_with_currency_format = "";
  Currency.moneyFormats[shopCurrency].money_format = "";

  /* Default currency */
  var defaultCurrency = 'GBP' || shopCurrency;

  /* Cookie currency */
  var cookieCurrency = Currency.cookie.read();

   /* Fix for customer account pages */
   jQuery('span.money span.money').each(function() {
     jQuery(this).parents('span.money').removeClass('money');
   });

   /* Saving the current price */
   jQuery('span.money').each(function() {
     jQuery(this).attr('data-currency-', jQuery(this).html());
   });

  var cookieCurrency = Currency.cookie.read();
  if(cookieCurrency == null || cookieCurrency == 'GBP')
  {
  	$('span.show-alt-currency').hide();
  }  else {
  	$('#currencies').val(cookieCurrency);
  	Currency.convertAll(shopCurrency, cookieCurrency);
  	
  	$('.currency-selector').removeClass('active');
    $('.currency-selector[data-value=' + cookieCurrency + ']').addClass('active');

  }

  $('.currency-selector').click(function(){
    $this = $(this);

    var selectedCurrency = $this.data('value');

    $this.siblings().removeClass('active');
    $this.addClass('active');

    if (selectedCurrency === 'GBP') {
      $('span.show-alt-currency').hide();
    } else {
      $('span.show-alt-currency').show();
      Currency.convertAll(shopCurrency, selectedCurrency);
      Currency.cookie.write(selectedCurrency);
      $('#currencies').val(selectedCurrency);
    }
  });
});